// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'shared/components/Icon';
import NavLink from './NavLink';
import NavOldLink from './NavOldLink';
import Submenu from './Submenu';

const Sidebar = ({ children }) => (
  <div id="sidebar">
    <a className="visible-phone">
      <Icon name="list" />
      Menu
    </a>

    <ul>{children}</ul>
  </div>
);

Sidebar.displayName = 'Sidebar';

Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
};

Sidebar.NavLink = NavLink;
Sidebar.NavOldLink = NavOldLink;
Sidebar.Submenu = Submenu;

export default Sidebar;
